/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Phone_Conflict_PrefixInputs */

const vi_customer_phone_conflict_prefix = /** @type {(inputs: Customer_Phone_Conflict_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số điện thoại này trùng với khách hàng:`)
};

/**

* @param {Customer_Phone_Conflict_PrefixInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_phone_conflict_prefix = /** @type {((inputs?: Customer_Phone_Conflict_PrefixInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Phone_Conflict_PrefixInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_phone_conflict_prefix(inputs)
});